export default "__VITE_ASSET__CQzvlEZU__"